
import vue from "vue";
import {
addDay,
setSessionStorage,
getSessionStorage,
removeSessionStorage,
getCookie,
setCookie
} from "@/common/js/utils.js";
import {
initWxJSSDK,
appointment,
getDefaultAddress,
checkOpenArea,
getPartner
} from "@/common/js/api.js";

import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'



export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle
},
methods: {
onSubmit() {
if( !this.entity.memo || this.entity.memo=="" ){
this.entity.toast = true;
this.entity.toastText = "驿站编号必须填写";
return ;
}
setCookie("birdmemo",this.entity.memo);
this.$router.push({ path: "/BirdAppointment" });
},

getDefaultAddress() {
let self = this;
getDefaultAddress({ data: {} }).then(function(data) {







});
},

initShare() {
let self = this;
self.$wechat.onMenuShareTimeline({
title: self.share.shareTitle, // 分享标题
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
success: function() {















},
cancel: function() {

}
});
self.$wechat.onMenuShareAppMessage({
title: self.share.shareTitle,
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
desc: self.share.shareDesc,
type: "link",
dataUrl: "",
success: function() {




},
cancel: function() {

}
});
}
},
data() {
return {
fromWhere: this.$route.query.fromWhere,
activityId: this.$route.query.activityId,
entity: {
memo: "",
appointTime: "预约时间",
addressId: "",
toast: false,
toastText: ""
},

share: {
shareTitle: "闲置衣物回收",
shareDesc: "闲置衣物回收",
shareUrl: ""
},
partnerId: "",
appointImage: "",
btnStyle: "",
bannerImage: ""
};
},
created() {
let self = this;
var birdmemo = getCookie("birdmemo");
if ( birdmemo ){
self.entity.memo = birdmemo
}

if (this.$route.query.partnerId) {

} else {
self.appointImage = "../../../static/images/intro.jpg?v=2";
self.bannerImage = "../../../static/images/ad3.png";
}

self.share.shareUrl =
window.location.protocol +
"//" +
window.location.hostname +
"/menu/appointment/" +
getCookie("authorizer_appid") +
"?k=1";

initWxJSSDK();
vue.wechat.ready(function(res) {
self.initShare();
});
let days = [];
let now = new Date();

this.getDefaultAddress();
}
};



// WEBPACK FOOTER //
// ./src/components/activity/bird/Insertnum.vue